import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabPanel = props => {
  const {
    selected = false
  } = props;
  const classes = classnames('ds-c-tabs__panel', props.className);
  return /*#__PURE__*/_jsx("div", {
    "aria-labelledby": props.tabId,
    "aria-hidden": !selected,
    className: classes,
    id: props.id,
    role: "tabpanel",
    children: props.children
  });
};

// Set component name to make child.type.displayName available to other components (eg. Tab)
TabPanel.displayName = 'TabPanel';
export default TabPanel;